import React, {useEffect} from 'react'
import styled from 'styled-components'
import {useWallet} from 'use-wallet'

import metamaskLogo from '../../assets/img/metamask-fox.svg'
import walletConnectLogo from '../../assets/img/wallet-connect.svg'

import Button from '../Button'
import Modal, {ModalProps} from '../Modal'
import ModalActions from '../ModalActions'
import ModalContent from '../ModalContent'
import ModalTitle from '../ModalTitle'
import Spacer from '../Spacer'

import WalletCard from './components/WalletCard'
import useModal from "../../hooks/useModal";
import {NetworkErrModel} from "../NetworkError/network_err";
import Card from "../Card";

const WalletProviderModal: React.FC<ModalProps> = ({onDismiss}) => {
    const {account, connect, chainId,ethereum} = useWallet();

    const [show] = useModal(<NetworkErrModel/>);

    useEffect(() => {
        if (account) {
            onDismiss()
        }
    }, [account, onDismiss]);

    return (
        <Modal>
            <ModalContent>
                {/*<Card>*/}
                    <StyledWalletsWrapper>
                        <StyledWalletCard>
                            <WalletCard
                                icon={<img src={metamaskLogo} style={{height: 32}}/>}
                                onConnect={async () => {

                                    // @ts-ignore
                                    if ( window['ethereum'].networkVersion && window['ethereum'].networkVersion != chainId) {
                                        onDismiss();
                                        show();
                                        return;
                                    }else{
                                        let bb = await connect('injected');
                                    }
                                    // show();
                                }}
                                title="Metamask"
                                subTitle='Connect to you MetaMask  Wallet'

                            />
                        </StyledWalletCard>
                        <Spacer size="sm"/>
                        <StyledWalletCard>
                            <WalletCard
                                icon={<img src={walletConnectLogo} style={{height: 24}}/>}
                                onConnect={() => connect('authereum')}
                                title="WalletConnect"
                                subTitle='Scan with WalletConnect to connect'
                            />
                        </StyledWalletCard>
                    </StyledWalletsWrapper>
                {/*</Card>*/}

            </ModalContent>
        </Modal>
    )
};

const StyledWalletsWrapper = styled.div`
  display: flex;
  // flex-wrap: wrap;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}px) {
    flex-direction: column;
  }
`;

const StyledWalletCard = styled.div`
  flex-basis: calc(50% - ${(props) => props.theme.spacing[2]}px);
  width:48%;
`;

export default WalletProviderModal
